import { useContext, useEffect, useState } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    Stack,
} from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

import { getMyLiveClasses } from "../api/courseAPI";
import { AuthContext } from "../theme/AuthContext";

export default function StudentLiveClasses() {
    const [classes, setClasses] = useState([]);
    const [loading, setLoading] = useState(false);

    const auth = useContext(AuthContext);
    const userId = auth.user?.username;

    useEffect(() => {
        if (userId) {
            fetchLiveClasses();
        }
    }, [userId]);

    const fetchLiveClasses = async () => {
        try {
            setLoading(true);
            const data = await getMyLiveClasses(userId);
            setClasses(data || []);
        } catch (error) {
            console.error("Live class fetch failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box p={3}>
            <Typography variant="h5" mb={3}>
                Upcoming Live Classes
            </Typography>

            {loading && <Typography>Loading live classes...</Typography>}

            {!loading && classes.length === 0 && (
                <Typography>No live classes scheduled</Typography>
            )}

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(3, 1fr)",
                        lg: "repeat(4, 1fr)",
                        xl: "repeat(5, 1fr)", //  5 cards per row
                    },
                    gap: 3,
                }}
            >
                {classes.map((cls) => {
                    const startDate = new Date(cls.startTime);

                    return (
                        <Card
                            key={cls.liveClassId}
                            sx={{
                                backgroundColor: "#ffffff",
                                borderRadius: 2,
                                boxShadow: "0px 4px 12px rgba(0,0,0,0.06)",
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                {/* Title */}
                                <Typography variant="h6" fontWeight={600} mb={2}>
                                    {cls.title}
                                </Typography>

                                {/* Date */}
                                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                    <CalendarMonthOutlinedIcon fontSize="small" color="action" />
                                    <Typography color="text.secondary">
                                        {startDate.toLocaleDateString()}
                                    </Typography>
                                </Stack>

                                {/* Time */}
                                <Stack direction="row" alignItems="center" spacing={1} mb={3}>
                                    <AccessTimeOutlinedIcon fontSize="small" color="action" />
                                    <Typography color="text.secondary">
                                        {startDate.toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </Typography>
                                </Stack>

                                {/* Join Button */}
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => window.open(cls.joinUrl, "_blank")}
                                    sx={{
                                        textTransform: "none",
                                        fontWeight: 600,
                                        borderRadius: 1.5,
                                    }}
                                >
                                    Join Live Class
                                </Button>
                            </CardContent>
                        </Card>
                    );
                })}
            </Box>

        </Box>
    );
}
